import { MainMenuItem } from "./InterfacesClient";
import { PostAdd, Group, Business, Home, CloudSync } from "@mui/icons-material";

export const iconColorsArray = ['SeaGreen', 'Maroon', 'DarkViolet', 'Red', 'Teal', 'DarkOrange', 'Blue', 'DarkGoldenrod', 'Magenta', 'Olive', 'Navy', 'Gold']


export enum GlobalRole {
    ADMIN = "ADMIN",
    SUPPLIER_ONBOARDING_MANAGER = "SUPPLIER-ONBOARDING-MANAGER",
    USER = "USER"
}

export enum RoutePathNames {
    LOGIN = "login",
    HOMEPAGE = "home",
    VENDORS = "vendors",
    VENDOR_USERS = "vendor-users",
    SUPPLEMENTARY_VENDOR_EMAIL_REQUESTS = "supplementary-vendor-email-requests",
    ONBOARD_PENDING_VENDORS = "onboard-pending-vendors"
}

export var MainMenu: MainMenuItem[] = [
    { index: 1, isSetupMenu: false, pathName: RoutePathNames.HOMEPAGE, header: '', displayinMenu: false, displayinDrawer: false, homePageIcon: <Home style={{ fontSize: 50 }}></Home> },
    { index: 2, isSetupMenu: false, pathName: RoutePathNames.VENDORS, header: 'Vendors', displayinMenu: true, displayinDrawer: true, homePageIcon: <Business style={{ fontSize: 60 }}></Business>, drawerIcon: <Business fontSize="large" /> },
    { index: 3, isSetupMenu: false, pathName: RoutePathNames.VENDOR_USERS, header: 'Vendor Users', displayinMenu: true, displayinDrawer: true, homePageIcon: <Group style={{ fontSize: 60 }}></Group>, drawerIcon: <Group fontSize="large" /> },
    { index: 4, isSetupMenu: false, pathName: RoutePathNames.SUPPLEMENTARY_VENDOR_EMAIL_REQUESTS, header: 'Supplementary Vendor Email Requests', displayinMenu: true, displayinDrawer: true, homePageIcon: <PostAdd style={{ fontSize: 60 }}></PostAdd>, drawerIcon: <PostAdd fontSize="large" /> },
    { index: 5, isSetupMenu: false, pathName: RoutePathNames.ONBOARD_PENDING_VENDORS, header: 'Onboard Pending Vendors', displayinMenu: true, displayinDrawer: true, homePageIcon: <CloudSync style={{ fontSize: 60 }}></CloudSync>, drawerIcon: <CloudSync fontSize="large" /> },

]
